import { CountrySelectField } from '@/kit/form/select/CountrySelect';
import { checkCountryForSepa } from '@/store/services/paymentServices';

// TODO Temporary solution, before backend can filter countries by self
const RESTRICTED_COUNTRIES = [
  'AC',
  'AF',
  'AM',
  'AS',
  'BS',
  'BW',
  'BY',
  'CD',
  'CF',
  'CG',
  'CS',
  'CU',
  'ET',
  'GH',
  'GU',
  'IQ',
  'IR',
  'KG',
  'KP',
  'KZ',
  'LK',
  'LY',
  'MD',
  'MM',
  'NG',
  'PA',
  'PK',
  'PR',
  'RS',
  'RU',
  'SA',
  'SD',
  'SO',
  'SS',
  'SY',
  'TN',
  'TT',
  'UZ',
  'VE',
  'VI',
  'WS',
  'YE',
];

export const SepaZoneCountrySelect = ({ onChange, ...props }) => {
  const checkForSepaZone = async country => {
    const res = await checkCountryForSepa(country.code);
    if (res?.success) {
      onChange({
        country,
        in_sepa_zone: res.data.in_sepa_zone,
      });
    }
  };
  return (
    <CountrySelectField exclude={RESTRICTED_COUNTRIES} onChange={checkForSepaZone} {...props} />
  );
};
